/*
 * @Author: your name
 * @Date: 2020-07-16 11:10:16
 * @LastEditTime: 2023-08-15 17:08:34
 * @LastEditors: bbqin
 * @Description: In User Settings Edit
 * @FilePath: \Platform_Front\src\platform\components\Form\compatible.js
 */
import React from "react";
import Form from "@platform/form";
import { localeLang, PubSub, isFunction, toast, ViewModel } from '@platform/api';
import { WithKeyboardChange } from '@platform/base';
import FormCardContainer from "./components/container/FormCardContainer";
const { createKeyMap } = WithKeyboardChange;
const { setFormDisableAttrCode } = createKeyMap;

import {
    focusToNext,
    focusNextItem,
} from './utils/enterkey';

/**
 * @description: 获取当前form的Store 
 * @param {type} 
 * @return: 
 */
function getStore(moduleId) {
    if (this.formDataSource && this.formDataSource[moduleId]) {
        return this.formDataSource[moduleId];
    } else {
        // console.warn('不存在formDataSource');
        // return null
        // 暂时通过error 提醒业务组、 稳定后可去掉
        console.error(`正在调用formID为${moduleId}的表单的API, 但此表单还未通过use.form注册,请先注册此ID，才能正常调用API`);
    }
}

/**
 * @description: 设置表单某项获取焦点
 * @param {moduleId} 
 * @param {attrcode} 
 * @return: 
 */
function setFormItemFocus(moduleId, attrcode) {
    if (moduleId && attrcode) {
        PubSub.publish('autoFocus', { data: attrcode,id:moduleId });
    }
}

/**
 * 聚焦到表单某一项
 * @param {*} param0 
 * @param {*} formId 
 */
function focusFormItem({ itemtype, attrcode }, formId) {
    focusNextItem({ itemtype, attrcode }, formId);
}

/**
 * 聚焦到表单 下一项  formId分为两个主要是为了分组
 * @param {*} attrcode 
 * @param {*} currenFormId 
 * @param {*} mainFormId 
 */
function focusFormNextItem(attrcode, currenFormId, mainFormId) {
    let moduleId = mainFormId || currenFormId;
    let currentStore = getStore.call(this, moduleId);
    console.log(attrcode, moduleId, currentStore, this);
    // focusToNext();
    let formComponent = currentStore.getRef();

    if (!formComponent || !formComponent.props) {
        return console.warn('not find formComponent!');
    }

    let { getHotKeyConfig = () => { } } = formComponent.props;
    let { meta, orderOfHotKey, onLastFormEnter } = getHotKeyConfig() || {};
    let formStore = currentStore.getInnerHooks();
    let { getStore: getDataStore, getAllFormItem } = formStore;
    // 處理states 數據 TODO 後面可以考慮優化下
    let items = getAllFormItem() || {};
    let states = {
        disabled: {},
        visible: {},
        form: {},
    };

    for (let key in items) {
        let item = items[key];
        states.disabled[item.attrcode] = !!item.disabled;
        states.visible[item.attrcode] = !!item.visible;
        states.form[item.attrcode] = item;
    }

    let params = {
        states,
        meta,
        moduleId,
        attrcode: attrcode,
        head: moduleId,
        formrelation: meta && meta.formrelation ? meta.formrelation[moduleId] : [moduleId],
        orderOfHotKey: orderOfHotKey,
        onLastFormEnter: onLastFormEnter,
        // itemType,
        formStore,
    };
    focusToNext(params);
}

/**
 * @description: 获取page、兼容处理编辑前编辑后等回调函数的第一个参数
 * @param {type} 
 * @return: 
 */
function getContext(config = {}, context = {}) {
    let newConfig = { ...config };

    newConfig.onBeforeEvent = function (...rest) {
        return typeof config.onBeforeEvent === 'function' ? config.onBeforeEvent.call(context, { ...context.props, ...context.output }, ...rest) : true;
    };

    newConfig.onBeforeValueChange = function (rest) {
        const {
            areaId, // 主表
            attrcode,
            value,
            oldValue,
            componentValue,
            allValue,
        } = rest;
        return typeof config.onBeforeValueChange === 'function' ? config.onBeforeValueChange.call(context, { ...context.props, ...context.output }, areaId, attrcode, value, oldValue, componentValue, allValue) : true;
    };

    newConfig.onAfterEvent = function (rest) {
        const {
            areaId, // 主表
            attrcode,
            curMetaItem, // 当前字段属性
            value,
            oldValue,
            componentValue,
            allValue,
            singleFormCode, // 当前子表ID
        } = rest;
        // 先执行字段控制规则，再执行公式，再走领域编辑后
        // 把执行字段控制规则的逻辑放在公式里，需要把 editAfterFlag 放在公式的逻辑里
        context.handleRelationItems({
            type: 'form',
            areaCode: areaId,
            formMetaCode: singleFormCode,
            key: attrcode,
            column: curMetaItem,
            value,
            callback: () => {
                typeof config.onAfterEvent === 'function' && config.onAfterEvent.call(context, { ...context.props, ...context.output }, areaId, attrcode, value, oldValue, componentValue, allValue);
            },
        });
        // if (curMetaItem.editAfterFlag && isFunction(context.handleRelationItems)) {
        //     context.handleRelationItems({
        //         type: 'form',
        //         areaCode: areaId,
        //         formMetaCode: singleFormCode,
        //         key: attrcode,
        //         value,
        //         callback: () => {
        //  typeof config.onAfterEvent === 'function' && config.onAfterEvent.call(context, { ...context.props, ...context.output }, areaId, attrcode, value, oldValue, componentValue, allValue);
        //         },
        //     });
        // } else {
        //   typeof config.onAfterEvent === 'function' && config.onAfterEvent.call(context, { ...context.props, ...context.output }, areaId, attrcode, value, oldValue, componentValue, allValue);
        // }

    };

    return newConfig;
}

/**
 * 创建表单
 * @memberof Form
 * @param {ModuleId} moduleId 主表ID
 * @param {Config} config 表单配置项
 * @returns {FormComponent}
 */
function createForm(moduleId, config = {}) {
    let currentStore = getStore.call(this, moduleId);
    //存一下dataSource
    const { setStore } = currentStore.getInnerHooks();
    setStore(['__datasources'], config.dataSource, false);
    let _runContext = this.getQiankunContext();
    return (
        <Form
            key={moduleId}
            store={currentStore}
            name={moduleId}
            config={getContext(config, this)}
            pageScope={this}
            // 快捷键 解耦
            getHotKeyConfig={() => {
                return {
                    pageScope: this,
                    autoFocusDeferred: this.autoFocusDeferred,
                    meta: this.state.meta,
                    withHotKeyChange: this.withHotKeyChange,
                    orderOfHotKey: this.orderOfHotKey,
                    onLastFormEnter: config.onLastFormEnter,
                };
            }}
            _runContext={_runContext}
        />
    );
}

/**
 * 创建表单卡片
 * @memberof Form
 * @param {ModuleId} moduleId 容器ID
 * @param {Config} config 表单卡片配置项
 * @returns {FormComponent}
 */
function createFormCard(moduleId, config = {}) {
    let currentStore = getStore.call(this, moduleId);
    return (
        <FormCardContainer
            key={moduleId}
            store={currentStore}
            cardContainerId={moduleId}
            config={config}
            pageScope={this}
            showContainer={true}
            // 快捷键 解耦
            getHotKeyConfig={() => {
                return {
                    pageScope: this,
                    meta: this.state.meta,
                };
            }}
        />
    );
}

/**
 * 设置表单全部数据
 * @memberof Form
 * @param {ItemData} formDataObj 表单数据
 * @param {Boolean} copyFlag
 * @param {Boolean} emptyOldVal
 * @param {Array} setOldValueExceptKey
 * @param {Function} callback
 * @param {Boolean} relationFlag 编辑关联项触发
 */
function setAllFormValue(formDataObj, copyFlag = true, emptyOldVal = false, setOldValueExceptKey, callback, relationFlag = false) {
    for (let moduleId of Object.keys(formDataObj)) {
        let newData = formDataObj[moduleId].rows[0].values,
            currentStore = getStore.call(this, moduleId);
        currentStore.setAllFormValue(newData, copyFlag, emptyOldVal, setOldValueExceptKey, callback, this, relationFlag);
        let eventListenerObj = currentStore.getEventListener();
        for (const key in eventListenerObj) {
            if (Object.hasOwnProperty.call(eventListenerObj, key)) {
                const callback = eventListenerObj[key];
                if (key === 'setAllFormValue' && Array.isArray(callback)) {
                    callback.forEach(fun => {
                        typeof fun === 'function' && fun(newData);
                    });
                }
            }
        }
    }
    this.controlRule.willRun('setAllFormValue');
}

/**
 * 获取表单所有数据
 * @memberof Form
 * @param {ModuleId|Array<ModuleId>} moduleIds 模板区域ID
 * @param {Object<inMeta, boolean>} params    
 * @returns {AllFormData} 
 */
function getAllFormValue(moduleIds, params = {}) {
    let { inMeta = false } = params;
    if (Array.isArray(moduleIds)) {
        let allFormData = {};
        for (let moduleId of moduleIds) {
            allFormData[moduleId] = getSingleData.call(this, moduleId, false, inMeta);
        }
        return allFormData;
    } else {
        return getSingleData.call(this, moduleIds, false, inMeta);
    }
}

/**
 * 获取单个表单数据
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {Boolean} isSimple
 * @param {Boolean} inMeta
 * @returns {AllFormData}
 */
function getSingleData(moduleId, isSimple = false, inMeta = false) {
    let currentStore = getStore.call(this, moduleId);
    let formData = isSimple ? setReferValueSimple(moduleId, currentStore.getAllFormValue(moduleId, inMeta)) : setReferValue(moduleId, currentStore.getAllFormValue(moduleId, inMeta));
    // 删除不必要的多语关系字段
    delete formData.langRelation;
    let data = { values: formData };
    let status = currentStore.getStatus();
    if (status == 'add') {
        data.status = '2';
    } else if (status == 'edit') {
        data.status = '1';
    }
    return {
        areaType: 'form',
        rows: [data],
    };
}

function getDataSource(moduleId) {
    let currentStore = getStore.call(this, moduleId);
    return currentStore.getInnerHooks().getStore(['__datasources']);
}

/**
 * 获取表单中某个字段的值
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {ItemKey|Array<ItemKey>} data 
 * @returns {Array<ItemData>}
 */
function getFormItemsValue(moduleId, data) {
    let currentStore = getStore.call(this, moduleId);
    if (currentStore) {
        if (Array.isArray(data)) {
            let newData = [];
            newData = data.map(item => {
                let result = null;
                result = currentStore.getItemValue(item);
                return result;
            });
            return newData;
        } else {
            let newData = currentStore.getItemValue(data, true);
            return newData;
        }
    } else {
        if (Array.isArray(data)) {
            let newData = [];
            newData = data.map(() => {
                return {
                    display: null,
                    value: null,
                };
            });
            return newData;

        } else {
            return {
                display: null,
                value: null,
            };
        }
    }
}

/**
 * 设置表单中某个字段的值
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {ItemData} values
 * @param {boolean} cancel
 * @param {boolean} setAllMultiLangValue
 * @param {boolean} shouldUpdate
 */
function setFormItemsValue(moduleId, values = {}, cancel = true, setAllMultiLangValue, shouldUpdate = false, params = {}) {
    const { callback = null } = params;
    let currentStore = getStore.call(this, moduleId);
    let needUpdate = false;
    const valuesArray = Object.keys(values);
    const valuesLength = valuesArray.length;
    for (let index = 0; index < valuesLength; index++) {
        const element = valuesArray[index];
        let itemtype = currentStore.getItemAttribute(element, 'itemtype');
        if (itemtype === 'number' || itemtype === 'residtxt') {
            needUpdate = true;
        }
        currentStore.setItemValue(element, { ...values[element] }, { cancel, setAllMultiLangValue, pageScope: this, callback: index === valuesLength - 1 ? callback : null });
    }
    // for (let key of Object.keys(values)) {
    //     let itemtype = currentStore.getItemAttribute(key, 'itemtype');
    //     if (itemtype === 'number' || itemtype === 'residtxt') {
    //         needUpdate = true;
    //     }
    //     currentStore.setItemValue(key, { ...values[key] }, { cancel, setAllMultiLangValue, pageScope: this, callback });
    // }
    // number的value值里有scale，属于props，需要整表更新；
    // NCC-189714 重新设值是否要更新
    needUpdate = needUpdate || shouldUpdate;
    needUpdate && currentStore.forceUpdate();
    this.controlRule.willRun('setFormItemsValue');
}

function updateAttachmentValue(moduleId, num, pkName, pkValue, dataSource) {
    let currentStore = getStore.call(this, moduleId);
    let value = `${num},${pkValue}`;
    let keys = currentStore.getInnerHooks().getStore(['_attachment']);
    if (Array.isArray(keys)) {
        keys.forEach(key => {
            currentStore.setItemValue(key, { display: value, value });
        });
    }
    //根据datasource更新缓存表格的附件值
    if (num === undefined || !pkValue || !pkName || !dataSource) { return; }
    let tableInfo = {};
    let tableData = ViewModel.getData(dataSource)?.simpleTable || {};
    let { pkname, attachmentCols, rows = [] } = tableData;
    // 缓存里没有附件列信息，就从表单里取
    if(!attachmentCols){
        attachmentCols = (keys || []).map(item => {return { attrcode:item };});
    }
    let finalPkName = pkName || pkname;
    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        if (rows[rowIndex].values[finalPkName].value === pkValue) {
            tableInfo.targetRowIndex = rowIndex;
            break;
        }
    }
    let { targetRowIndex } = tableInfo;
    if (tableInfo.targetRowIndex !== undefined) {
        attachmentCols.forEach(col => {
            let attachmentValue = rows[targetRowIndex].values[col.attrcode];
            if (!attachmentValue.value) {
                attachmentValue.value = `${num},${pkValue}`;
            } else {
                let [, value] = attachmentValue.value.split(',');
                attachmentValue.value = `${num},${value}`;
            }
        });
    }
    currentStore.forceUpdate();
}

/**
 * 获取表单某个或某些字段的编辑性
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {ItemKey|Array<ItemKey>} keys
 * @return {boolean|Array<boolean>}
 */
function getFormItemsDisabled(moduleId, keys) {
    let currentStore = getStore.call(this, moduleId);

    if (Array.isArray(keys)) {
        let res = [];
        res = keys.map(item => {
            return !!currentStore.getItemAttribute(item, 'disabled');
        });
        return res;
    } else {
        return !!currentStore.getItemAttribute(keys, 'disabled');
    }
}

/**
 * 设置表单编辑性
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {Object<ItemKey, boolean>} values
 */
function setFormItemsDisabled(moduleId, values) {
    let currentStore = getStore.call(this, moduleId);
    currentStore.setItemAttribute('disabled', values, null, !this.isUpdatePage);
    // setFormDisableAttrCode 
    let { getAllFormItem } = currentStore.getInnerHooks();
    // 處理states 數據 TODO 後面可以考慮優化下
    let items = getAllFormItem() || {};
    let disabledItems = {};
    for (let key in items) {
        let item = items[key];
        disabledItems[item.attrcode] = !!item.disabled;
    }
    setFormDisableAttrCode(moduleId, disabledItems);

}

/**
 * 设置表单某些字段的必输性
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {Object<ItemKey, boolean>} values
 */
function setFormItemsRequired(moduleId, values) {
    let currentStore = getStore.call(this, moduleId);
    currentStore.setItemAttribute('required', values, null, !this.isUpdatePage);
}

/**
 * 设置表单某些字段的属性
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {ItemKey} name 表单项的唯一标识
 * @param {MetaItem} attribute disable:禁用状态 verify:校验状态 visible:可见状态 required:必输性
 * @param {string|boolean|null|undefined} value 表单项的属性值
 */
function setFormItemsAttribute(moduleId, name, attribute, value, options = {}) {
    let currentStore = getStore.call(this, moduleId);
    let { shouldUpdate = true, ...others } = options;
    currentStore.setItemAttribute(name, attribute, value, shouldUpdate, others);
}

function getFormItemsAttribute(moduleId, name, attribute) {
    let currentStore = getStore.call(this, moduleId);
    return currentStore.getItemAttribute(name, attribute);
}

/**
 * 设置关键信息区某些字段的属性
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {ModuleId} cardFormId 信息卡片关联的表单ID
 * @param {ItemKey} name 表单项的唯一标识
 * @param {MetaItem} attribute disable:禁用状态 verify:校验状态 visible:可见状态 required:必输性
 * @param {string|boolean|null|undefined} value 表单项的属性值
 */
function setFormCardItemAttribute(moduleId, cardFormId, name, attribute, value, options = {}) {
    let currentStore = getStore.call(this, moduleId);
    let { shouldUpdate = true, ...others } = options;
    currentStore.setCardItemAttribute(cardFormId, name, attribute, value, shouldUpdate, others);
}

/**
 * 获取表单某些字段的必输性
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {ItemKey|array<ItemKey>} 表单项的唯一标识
 * @returns {boolean|array<boolean>} 表单项的必输性
 */
function getFormItemsRequired(moduleId, keys) {
    let currentStore = getStore.call(this, moduleId);

    if (Array.isArray(keys)) {
        let res = [];
        res = keys.map(item => {
            return !!currentStore.getItemAttribute(item, 'required');
        });
        return res;
    } else {
        return !!currentStore.getItemAttribute(keys, 'required');
    }
}

/**
 * 获取表单某些字段的所有属性
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {ItemKey|array<ItemKey>} 表单项的唯一标识
 * @returns {Array<object>|object} 返回字段属性 
 */
function getFormItem(moduleId, keys) {
    let currentStore = getStore.call(this, moduleId);

    if (Array.isArray(keys)) {
        let res = [];
        res = keys.map(item => {
            return currentStore.getFormItem(item);
        });
        return res;
    } else {
        return currentStore.getFormItem(keys);
    }
}

/**
 * 获取表单某些字段的显隐性
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {ItemKey|array<ItemKey>} 表单项的唯一标识
 * @returns {boolean|array<boolean>} 表单项的显隐性
 */
function getFormItemsVisible(moduleId, keys) {
    let currentStore = getStore.call(this, moduleId);

    if (Array.isArray(keys)) {
        let res = [];
        res = keys.map(item => {
            return !!currentStore.getItemAttribute(item, 'visible');
        });
        return res;
    } else {
        return !!currentStore.getItemAttribute(keys, 'visible');
    }
}

/**
 * 设置表单某些字段的显隐性
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {Object<ItemKey, boolean>} values
 */
function setFormItemsVisible(moduleId, values) {
    let currentStore = getStore.call(this, moduleId);
    currentStore.setItemAttribute('visible', values, null, !this.isUpdatePage);
}

/**
 * @description: 设置表单某些字段的校验规则 (待废弃)
 * @param {type} 
 * @return: 
 */
function setFormItemsVerify(moduleId, keys) {
    // TODO: 2005版没对这个方法做实现
    let currentStore = getStore.call(this, moduleId);

    if (Array.isArray(keys)) {
        let res = [];
        res = keys.map(item => {
            return !!currentStore.getItemAttribute(item, 'verify');
        });
        return res;
    } else {
        return !!currentStore.getItemAttribute(keys, 'verify');
    }
}

/**
 * @description: 设置表单某些字段的校验规则（待废弃）
 * @param {type} 
 * @return: 
 */
function getFormItemsVerify(moduleId, values) {
    // TODO: 这里逻辑有问题，2005版没对这个方法做实现
    let currentStore = getStore.call(this, moduleId);
    currentStore.setItemAttribute('verify', values);
}

/**
 * 清空表单所有数据
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {array<ItemKey>} exceptArr 表单项的唯一标识
 * @param {boolean} cancel 
 */
function EmptyAllFormValue(moduleId, exceptArr, cancel = true) {
    let currentStore = getStore.call(this, moduleId);
    const pageScope = this;
    currentStore.emptyAllFormValue(exceptArr, cancel, pageScope);
    let eventListenerObj = currentStore.getEventListener();
    for (const key in eventListenerObj) {
        if (Object.hasOwnProperty.call(eventListenerObj, key)) {
            const callback = eventListenerObj[key];
            if (key === 'EmptyAllFormValue' && Array.isArray(callback)) {
                callback.forEach(fun => {
                    typeof fun === 'function' && fun();
                });
            }
        }
    }

}

/**
 * 清空表单所有数据
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {array<ItemKey>} exceptArr 表单项的唯一标识
 * @param {boolean} cancel 
 */
function emptyAllFormValue(moduleId, exceptArr, cancel = true) {
    let currentStore = getStore.call(this, moduleId);
    const pageScope = this;
    currentStore.emptyAllFormValue(exceptArr, cancel, pageScope);
    let eventListenerObj = currentStore.getEventListener();
    for (const key in eventListenerObj) {
        if (Object.hasOwnProperty.call(eventListenerObj, key)) {
            const callback = eventListenerObj[key];
            if (key === 'EmptyAllFormValue' && Array.isArray(callback)) {
                callback.forEach(fun => {
                    typeof fun === 'function' && fun();
                });
            }
        }
    }

}

/** 
 * 表单检验(必填,正则校验)
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {string<'danger'|'info'|'waring'|'success'>} type 校验不通过提示信息类型
 * @param {boolean} firstAutoFocus 校验不通过首项聚焦
 * @returns {boolean} 是否校验通过 
 */
function isCheckNow(moduleId, type = 'danger', firstAutoFocus = true) {
    let requiredItems = [],
        regItems = [],
        maxItems = [],
        flag = true,
        hasError = false,
        toastStore;
    if (Array.isArray(moduleId)) {
        moduleId.forEach((item, index) => {
            let currentStore = getStore.call(this, item);
            if (index === 0) { toastStore = currentStore; }
            let res = currentStore.isCheckNow(firstAutoFocus && !hasError);
            if (!hasError && res.hasError) { hasError = res.hasError; }
            requiredItems = requiredItems.concat(res.requiredItems);
            regItems = regItems.concat(res.regItems);
            maxItems = maxItems.concat(res.maxItems);
        });
    } else {
        let currentStore = getStore.call(this, moduleId);
        toastStore = currentStore;
        ({ requiredItems, regItems, maxItems } = currentStore.isCheckNow(firstAutoFocus));
    }
    if (requiredItems.length || regItems.length || maxItems.length) {
        flag = false;

        let json = toastStore.getInnerHooks().getJson();

        let toastContent = '';

        if (requiredItems.length) {
            toastContent += `${json['page-form-0001']}：${requiredItems.join(', ')}\n`;
        }
        if (regItems.length) {
            // 筛选下 有 regMessage 和 没有的
            let hasMessageItem = regItems.filter(item => item.regMessage);
            let noMessageItem = regItems.filter(item => !item.regMessage).map(ele => ele.label);
            hasMessageItem.forEach(item => {
                toastContent += `${item.label}：${item.regMessage}\n`;
            });
            noMessageItem.length && (toastContent += `${json['page-form-0002'] || '以下字段不合法'}：${noMessageItem.join(',')}\n`);
        }
        // if (regItems.length) {
        //     toastContent += `${json['page-form-0002']}：${regItems.join(', ')}\n`;
        // }
        if (maxItems.length) {
            toastContent += `${json['page-form-0010']}：${maxItems.join(', ')}`;
        }

        toast({
            mark: 'form_isCheckNow',
            color: type,
            title: json['page-form-0009'],
            content: toastContent,
        });
    }
    return flag;
}

/**
 * 展开表单某个区域
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {ModuleId} groupId 模板区域ID
 */
function openArea(moduleId, groupId) {
    let currentStore = getStore.call(this, moduleId);
    currentStore && currentStore.openArea(groupId);
}

/**
 * 收起表单某个区域
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {ModuleId} groupId 模板区域ID
 */
function closeArea(moduleId, groupId) {
    let currentStore = getStore.call(this, moduleId);
    currentStore && currentStore.closeArea(groupId);
}

/**
 * 设置表单某个区域展开收起
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {ModuleId} groupId 模板区域ID
 * @param {boolean} visible true展示 false收起
 */
function setAreaVisible(moduleId, groupId, visible) {
    let currentStore = getStore.call(this, moduleId);
    currentStore && currentStore.setAreaVisible(groupId, visible);
}

/**
 * 获取表单某个区域的展开收起状态
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {ModuleId} groupId 模板区域ID
 * @returns {boolean} true展示 false收起
 */
function getAreaVisible(moduleId, groupId) {
    let currentStore = getStore.call(this, moduleId);
    if (currentStore) {
        return currentStore.getAreaVisible(groupId);
    }
}

/**
 * 激活表单某个tab
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {string} activeTabCode tab区域ID
 */
function setActiveTab(moduleId, activeTabCode) {
    let currentStore = getStore.call(this, moduleId);
    currentStore && currentStore.getInnerHooks().setFormTabs(activeTabCode);
}

/**
 * 获取表单某当前激活的tab
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @returns {string} activeTabCode tab区域ID
 */
function getActiveTab(moduleId) {
    let currentStore = getStore.call(this, moduleId);
    if (currentStore) {
        return currentStore.getInnerHooks().getFormTabs();
    }
}

/**
 * 表单取消方法
 * @memberof Form
 * @param {ModuleId|array<ModuleId>} moduleIds 模板区域ID
 */
function cancel(moduleIds) {
    if (Array.isArray(moduleIds)) {
        for (let moduleId of moduleIds) {
            let currentStore = getStore.call(this, moduleId);
            currentStore.cancel();
        }
    } else {
        let currentStore = getStore.call(this, moduleIds);
        currentStore.cancel();
    }
}

/**
 * 设置表单status
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @param {string<'add'|'edit'|'browse'>} status 表单状态
 */
function setFormStatus(moduleId, status) {
    let currentStore = getStore.call(this, moduleId);
    // let oldStatus = currentStore.getStatus();
    currentStore.setStatus(status, !this.isUpdatePage);
    this.controlRule.willRun("setFormStatus");
    // if (oldStatus !== status) {
    //     let eventListenerObj = currentStore.getEventListener();
    //     for (const key in eventListenerObj) {
    //         if (Object.hasOwnProperty.call(eventListenerObj, key)) {
    //             const callback = eventListenerObj[key];
    //             if (key === 'statusChange' && Array.isArray(callback)) {
    //                 callback.forEach(fun => {
    //                     typeof fun === 'function' && fun(status);
    //                 });
    //             }
    //         }
    //     }
    // }
}

/**
 * 获取表单status
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 * @returns {string<'add'|'edit'|'browse'>}  表单状态
 */
function getFormStatus(moduleId) {
    let currentStore = getStore.call(this, moduleId);
    return currentStore.getStatus();
}

/**
 * @description: 检验是否必填 没看出来有什么用处 （待废弃）
 * @param {String} 
 * @return: Boolean
 */
function checkRequired() {
    return false;
}

/**
 * 表单重新计算宽度
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID
 */
function resetItemWidth(moduleId) {
    let currentStore = getStore.call(this, moduleId);
    currentStore.countFormWidth();
}

/**
 * @description: 自动获取焦点API
 * @param {moduleId} 
 * @param {attrcode} 
 * @return: 
 */
function setFormItemAutoFocus(moduleId, attrcode) {
    let currentStore = getStore.call(this, moduleId);
    console.log(moduleId);
    currentStore.getInnerHooks().setStore('autoFocusFormItem', attrcode);
}

/**
 * @description: 更新表单 （待废弃）
 * @param {String/Array} 
 * @return: 
 */
function updateForm(moduleId) {
    let currentStore = getStore.call(this, moduleId);
    currentStore.forceUpdate();
}

/**
 * 获取表单所有简化版数据
 * @memberof Form
 * @param {ModuleId|array<ModuleId>} moduleIds 模板区域ID
 * @param {Object<inMeta, boolean>} params 其他参数 
 * @returns {FormData|Object<ModuleId, FormData>} 表单简化版数据
 */
function getAllFormValueSimple(moduleIds, params = {}) {
    let { inMeta = false } = params;
    if (Array.isArray(moduleIds)) {
        let allFormData = {};
        for (let moduleId of moduleIds) {
            allFormData[moduleId] = getSingleData.call(this, moduleId, true, inMeta);
            return allFormData;
        }
    } else {
        return getSingleData.call(this, moduleIds, true, inMeta);
    }
}

/**
 * @description: 简化表单每一项数据
 * @param {moduleId} 
 * @param {formData} 
 * @return: Object
 */
function setReferValueSimple(moduleId, formData = {}) {
    let newData = {};
    // Object.keys(formData).forEach(pop => {
    //     if (!isEmpty(formData[pop].value)) {
    //         newData[pop] = { value: formData[pop].value };
    //     } else {
    //         newData[pop] = {};
    //     }
    // })
    for (let pop in formData) {
        if (!isEmpty(formData[pop].value)) {
            newData[pop] = { value: formData[pop].value };
        } else {
            newData[pop] = {};
        }
    }
    return newData;
}

/**
 * @description: 判断第一个参数是否为空，后面可以传其他【认为是空值】的参数
 * @param {} 
 * @return: Boolean
 */
function isEmpty(val, ...rest) {
    if (val === null || val === undefined || rest.find(e => e == val)) {
        return true;
    }
    return false;
}

/**
 * 设置显隐性
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID 
 * @param {Object<ItemKey, boolean>} values
 * @return: 
 */
function setItemsVisible(moduleId, values) {
    setFormItemsVisible.call(this, moduleId, values);
}

/**
 * @description: attrcode 获取 当前登录语言的 attrcode （待废弃）
* @param  moduleId String  form的id号 
 * @param  attrcode String 字段
 * @return: 
 */
function getResidtxtLang(moduleId, attrcode) {
    return attrcode;
}

function setFormPopConfirmSwitchTips(moduleId) {

}

/**
 * 更新表单数据
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID 
 * @param {Object<string, string | boolean>} newData 数据 
 * @param {ItemKey} pkname 表单项的唯一标识 
 */
function updateDataByRefresh(moduleId, newData, pkname) {
    let currentStore = getStore.call(this, moduleId);

    if (currentStore && newData) {
        let FormData = getAllFormValue.call(this, moduleId);
        FormData = FormData.rows ? FormData.rows[0] : {};
        FormData = FormData.values ? FormData.values : {};
        //let newData = refreshData[0];
        let pknameValue = FormData[pkname] ? (FormData[pkname].value || FormData[pkname].display || FormData[pkname]) : '';
        // 根据pkname进行更新 
        if (pkname && pknameValue == newData[pkname]) {
            for (let pop in newData) {
                FormData[pop] = {
                    ...FormData[pop],
                    value: newData[pop],
                };
            }
            currentStore.setAllFormValue(FormData, false, false, false, null, this);
        }
        console.log('update form data by pkname:', pkname);
    }
    this.controlRule.willRun('updateDataByRefresh');
}

function clearFormVerify(moduleId) {

}

/**
 * @description: 设置参照值
 * @param {moduleId} 
 * @param {formData} 
 * @return: 
 */
function setReferValue(moduleId, formData) {
    let newResData = {}; //新加--提高效率
    for (let pop in formData) {
        let result = null;
        if (formData[pop]) {
            if (Object.prototype.toString.call(formData[pop].value).slice(8, -1) === 'String') {
                //formData[pop].value = formData[pop].value.trim();
                formData[pop].value = formData[pop].value
            }
            result = {
                display: formData[pop].display,
                value: formData[pop].value,
            };
            if (formData[pop].hasOwnProperty('scale')) {
                result.scale = formData[pop].scale;
            }
        }
        //formData[pop] = result;
        newResData[pop] = result;//新加--提高效率
    }
    return newResData;
}

/**
 * @description: 重置表单，没有输出，（待废弃）
 * @param moduleId String  form id 
 */
function reset(moduleId) {
    let currentStore = getStore.call(this, moduleId);
    currentStore.reset();
}

/**
 * 清空表单数据（清空默认值）
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID 
 */
function clearFormValue(moduleId, params = {}) {
    let currentStore = getStore.call(this, moduleId);
    const pageScope = this;
    currentStore.clearFormValue(params, pageScope);
    this.controlRule.willRun('clearFormValue');
}
/**
 * 表单监听事件
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID 
 * @param {string} eventName 事件名，目前仅支持setAllFormValue（全表赋值）、EmptyAllFormValue（清空数据）、statusChange（表单状态变化）
 * @param {function} callback 回调方法 
 */
function addEventListener(moduleId, eventName, callback) {
    let currentStore = getStore.call(this, moduleId);
    currentStore.setEventListener(eventName, callback);
}

/**
 * 表单监听字段改变事件
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID 
 * @param {ItemKey|Array<ItemKey>} attrcode  字段唯一属性 
 * @param {function} callback  回调方法 
 * @param {boolean} innerChange  编辑过程中触发 默认false 
 * @param {boolean} shareChange  多字段公用一个callback 默认false 
 */
function addFormItemListener(moduleId, itemKey, callback, innerChange = false, shareChange = false) {
    itemKey = Array.isArray(itemKey) ? itemKey : [itemKey];
    this.formEventListener[moduleId] = this.formEventListener[moduleId] || {};
    callback.innerChange = innerChange;
    if (shareChange) {
        callback.shareChange = itemKey;
    }
    itemKey.forEach(itemCode => {
        this.formEventListener[moduleId][itemCode] = this.formEventListener[moduleId][itemCode] || [];
        this.formEventListener[moduleId][itemCode].push(callback);
    });
}

/**
 * 表单移除字段改变事件
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID 
 * @param {ItemKey|Array<ItemKey>} attrcode  字段唯一属性 
 */
function removeFormItemListener(moduleId, itemKey, callback) {
    itemKey = Array.isArray(itemKey) ? itemKey : [itemKey];
    this.formEventListener[moduleId] = this.formEventListener[moduleId] || {};
    itemKey.forEach(itemCode => {
        let callbackArr = this.formEventListener[moduleId][itemCode] || [];
        let index = callbackArr.indexOf(callback);
        index > -1 && callbackArr.splice(index, 1, null);
    });
}

/**
 * 根据模板元数据设置默认值
 * @memberof Form
 * @param {ModuleId} moduleId 模板区域ID 
 */
function setDefaultValueFromMeta(moduleId, params = {}){
    let { exceptArr = [] } = params;
    let currentStore = getStore.call(this, moduleId);
    currentStore.setDefaultValueFromMeta({ formId: moduleId, pageScope: this, exceptArr });
}

export {
    createForm,
    setAllFormValue,
    getAllFormValue,
    getAllFormValueSimple,
    clearFormValue,
    EmptyAllFormValue,
    // 放一个小驼峰的清空表单的 API
    emptyAllFormValue,
    cancel,
    setFormItemsValue,
    getFormItemsValue,
    updateDataByRefresh,
    setFormStatus,
    getFormStatus,
    getFormItemsDisabled,
    setFormItemsDisabled,
    setFormItemsRequired,
    getFormItemsRequired,
    getFormItemsVisible,
    setFormItemsVisible,
    getFormItem,
    setItemsVisible,
    setFormItemsVerify,
    getFormItemsVerify,
    setFormItemsAttribute,
    getFormItemsAttribute,
    setFormItemFocus,
    focusFormItem,
    focusFormNextItem,
    openArea,
    closeArea,
    setAreaVisible,
    getAreaVisible,
    resetItemWidth,
    setActiveTab,
    getActiveTab,
    addEventListener,
    isCheckNow,
    addFormItemListener,
    removeFormItemListener,
    updateAttachmentValue,
    // 根据模版设置默认值
    setDefaultValueFromMeta,
    // 创建表单卡片
    createFormCard,
    // 设置关键信息区属性
    setFormCardItemAttribute,

    // 设置自动聚集的属性 未实现 待废弃
    setFormItemAutoFocus,
    // 获取 当前登录语言的 attrcode 待废弃
    getResidtxtLang,
    // 检验是否必填 待废弃
    checkRequired,
    // 清空表单校验 待废弃
    clearFormVerify,
    // 更新表单 待废弃
    updateForm,
    // 设置confirm tips 待废弃
    setFormPopConfirmSwitchTips,
    // reset,
    getDataSource,
};